import Form from 'components/Profile/Consent/Form';

const Consent = () => <Form />;

export default Consent;
